import { RouteConfig } from "vue-router";

// Account management
import AccountListPage from "@/views/pages/admin/account/accountListPage.vue";
// Blog
import BlogEditPage from "@/views/pages/admin/blog/blogEditPage.vue";
import BlogListPage from "@/views/pages/admin/blog/blogListPage.vue";
import BlogPreviewPage from "@/views/pages/admin/blog/blogPreviewPage.vue";
// Carpsale history
import CarpsaleHistoryListPage from "@/views/pages/admin/carpsaleHistory/carpsaleHistoryListPage.vue";
// Live
import LiveCreatePage from "@/views/pages/admin/live/liveCreatePage.vue";
import LiveEditPage from "@/views/pages/admin/live/liveEditPage.vue";
import LiveListPage from "@/views/pages/admin/live/liveListPage.vue";
import LivePreviewPage from "@/views/pages/admin/live/livePreviewPage.vue";
// News
import NewsEditPage from "@/views/pages/admin/news/newsEditPage.vue";
import NewsListPage from "@/views/pages/admin/news/newsListPage.vue";
import NewsPreviewPage from "@/views/pages/admin/news/newsPreviewPage.vue";
// Store history
import StoreHistoryListPage from "@/views/pages/admin/storeHistory/storeHistoryListPage.vue";
// import LivePreviewListPage from "@/views/pages/admin/live/livePreviewListPage.vue";

// Bid
import BidListPage from "@/views/pages/admin/bid/bidListPage.vue";

// Event
import EventEditPage from "@/views/pages/admin/event/eventEditPage.vue";
import EventListPage from "@/views/pages/admin/event/eventListPage.vue";
import EventPreviewPage from "@/views/pages/admin/event/eventPreviewPage.vue";
import EventReceptPage from "@/views/pages/admin/event/eventReceptPage.vue";
import EventSettingPage from "@/views/pages/admin/event/eventSettingPage.vue";
import EventSettingPrintPage from "@/views/pages/admin/event/eventSettingPrintPage.vue";
import EventTicketListPage from "@/views/pages/admin/event/eventTicketListPage.vue";
import EventRemotePage from "@/views/pages/admin/eventRemote/eventRemotePage.vue";

// Contents
import ContentsListPage from "@/views/pages/admin/contents/contentsListPage.vue";
import DownloadListPage from "@/views/pages/admin/download/downloadListPage.vue";

// Show
import ShowEditPage from "@/views/pages/admin/show/showEditPage.vue";
import ShowListPage from "@/views/pages/admin/show/showListPage.vue";
import ShowPreviewPage from "@/views/pages/admin/show/showPreviewPage.vue";

// Magazines
import MagazinesListPage from "@/views/pages/admin/magazines/magazinesListPage.vue";

// Store
import StoreEditPage from "@/views/pages/admin/store/storeEditPage.vue";
import StoreListPage from "@/views/pages/admin/store/storeListPage.vue";
import StorePreviewPage from "@/views/pages/admin/store/storePreviewPage.vue";

// Store category
import StoreCategoryListPage from "@/views/pages/admin/storeCategory/storeCategoryListPage.vue";

// Carpsale
import CarpsaleEditPage from "@/views/pages/admin/carpsale/carpsaleEditPage.vue";
import CarpsaleListPage from "@/views/pages/admin/carpsale/carpsaleListPage.vue";
import CarpsalePreviewPage from "@/views/pages/admin/carpsale/carpsalePreviewPage.vue";

// Carp category
import CarpCategoryListPage from "@/views/pages/admin/carpCategory/carpCategoryListPage.vue";

// Member
import MemberEditPage from "@/views/pages/admin/member/memberEditPage.vue";
import MemberListPage from "@/views/pages/admin/member/memberListPage.vue";

// Setting
import SettingListPage from "@/views/pages/admin/setting/settingListPage.vue";

// Admin logout
import LogoutPage from "@/views/pages/logoutPage.vue";

import AdminLayout from "@/views/layouts/admin/qMaster.vue";

// import NaritaKoiLayout from "@/views/layouts/admin/naritaKoi.vue";
import { ROLE_ADMIN, ROLE_MANAGER } from "@/common/constant";
import NaritaKoiLayout from "@/views/layouts/narita-koi.com/qMaster.vue";
import No1KoiLayout from "@/views/layouts/no1koi.com/qMaster.vue";
import AuctionListPage from "@/views/pages/admin/auction/auctionListPage.vue";
import CarpsaleHistoryChatPdfPage from "@/views/pages/admin/carpsaleHistory/carpsaleHistoryChatPdfPage.vue";
import LivePdfPage from "@/views/pages/admin/live/livePdfPage.vue";
import StoreHistoryChatPdfPage from "@/views/pages/admin/storeHistory/storeHistoryChatPdfPage.vue";
import forbidden from "@/views/pages/forbidden.vue";
import notFound from "@/views/pages/notFound.vue";
import serverDown from "@/views/pages/serverDown.vue";

const adminRouter: RouteConfig[] = [
  {
    path: "/",
    name: "admin.default",
    redirect: "news",
  },
  {
    path: "/live/pdf",
    name: "admin.live.pdf",
    component: LivePdfPage,
    meta: {
      pageTitle: "証明書",
      title: "証明書",
      subTitle: "",
      className: "Live",
      bodyClass: "A5 landscape",
      allowRole: [ROLE_ADMIN],
      allowPermission: ["edit_live"],
    },
  },
  {
    path: "/event/ticket/:id",
    name: "admin.event.ticket",
    component: EventTicketListPage,
    meta: {
      pageTitle: "抽選券印刷",
      title: "抽選券印刷",
      subTitle: "",
      className: "Event",
      bodyClass: "A4 Ticket",
      allowRole: [ROLE_ADMIN],
    },
  },
  {
    path: "/store-history/chat/print",
    name: "admin.store_history.chat.print",
    component: StoreHistoryChatPdfPage,
    meta: {
      pageTitle: "ストア注文管理 | 成田養魚園管理者専用サイト",
      title: "ストア注文管理 | 成田養魚園管理者専用サイト",
      subTitle: "",
      bodyClass: "A4 StoreChat",
      allowRole: [ROLE_ADMIN],
    },
  },
  {
    path: "/carpsale-history/chat/print",
    name: "admin.carpsale_history.chat.print",
    component: CarpsaleHistoryChatPdfPage,
    meta: {
      pageTitle: "錦鯉販売注文管理 | 成田養魚園管理者専用サイト",
      title: "錦鯉販売注文管理 | 成田養魚園管理者専用サイト",
      subTitle: "",
      bodyClass: "A4 StoreChat",
      allowRole: [ROLE_ADMIN],
    },
  },
  {
    path: "/event-remote/:id",
    name: "admin.event-lottery.remote",
    component: EventRemotePage,
    meta: {
      pageTitle: "抽選結果操作 | 成田養魚園管理者専用サイト",
      title: "抽選結果操作 | 成田養魚園管理者専用サイト",
      subTitle: "",
      className: "",
      bodyClass: "Ctrl SlotPage",
      allowRole: [ROLE_ADMIN],
    },
  },
  {
    path: "/setting/print/:id",
    name: "admin.setting.print",
    component: EventSettingPrintPage,
    meta: {
      pageTitle: "店頭イベント管理 | 成田養魚園管理者専用サイト",
      title: "店頭イベント管理 | 成田養魚園管理者専用サイト",
      subTitle: "",
      bodyClass: "A4 Winner",
      allowRole: [ROLE_ADMIN],
    },
  },
  {
    path: "",
    name: "no1koi",
    component: No1KoiLayout,
    redirect: "login",
    meta: {
      allowRole: [ROLE_ADMIN],
    },
    children: [
      {
        path: "/live/preview",
        name: "admin.live.preview",
        component: LivePreviewPage,
        meta: {
          pageTitle: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          title: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Live",
          bodyClass: "Live Preview",
          allowRole: [ROLE_ADMIN],
          allowPermission: ["edit_live"],
        },
      },
    ],
  },
  {
    path: "",
    name: "narita",
    component: NaritaKoiLayout,
    redirect: "login",
    meta: {
      allowRole: [ROLE_ADMIN],
    },
    children: [
      {
        path: "/news/preview",
        name: "admin.news.preview",
        component: NewsPreviewPage,
        meta: {
          pageTitle: "お知らせ管理 | 成田養魚園管理者専用サイト",
          title: "お知らせ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "News",
          allowRole: [ROLE_ADMIN],
          bodyClass: "News Preview",
        },
      },
      {
        path: "/blog/preview",
        name: "admin.blog.preview",
        component: BlogPreviewPage,
        meta: {
          pageTitle: "ブログ管理 | 成田養魚園管理者専用サイト",
          title: "ブログ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Blog",
          allowRole: [ROLE_ADMIN],
          bodyClass: "Blog Preview",
        },
      },
      {
        path: "/show/preview",
        name: "admin.show.preview",
        component: ShowPreviewPage,
        meta: {
          pageTitle: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          title: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Show",
          allowRole: [ROLE_ADMIN],
          bodyClass: "Show Preview",
        },
      },
      {
        path: "/store/preview",
        name: "admin.store.preview",
        component: StorePreviewPage,
        meta: {
          pageTitle: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          title: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Store",
          allowRole: [ROLE_ADMIN],
          bodyClass: "Store Preview",
        },
      },
      {
        path: "/carpsale/preview",
        name: "admin.carpsale.preview",
        component: CarpsalePreviewPage,
        meta: {
          pageTitle: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          title: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Koisale",
          allowRole: [ROLE_ADMIN],
          bodyClass: "Carpsale Preview",
        },
      },
      {
        path: "event/preview/",
        name: "admin.event.preview",
        component: EventPreviewPage,
        meta: {
          pageTitle: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          title: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Event",
          allowRole: [ROLE_ADMIN],
          bodyClass: "Event Preview",
        },
      },
    ],
  },
  {
    path: "",
    name: "admin",
    component: AdminLayout,
    redirect: "login",
    meta: {
      allowRole: ["admin"],
    },
    children: [
      {
        path: "account",
        name: "admin.account.index",
        component: AccountListPage,
        meta: {
          pageTitle: "アカウント管理 | 成田養魚園管理者専用サイト",
          title: "アカウント管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Account",
          allowRole: [ROLE_ADMIN],
          allowPermission: ["browse_account"],
        },
      },
      {
        path: "news",
        name: "admin.news.index",
        component: NewsListPage,
        meta: {
          pageTitle: "お知らせ管理 | 成田養魚園管理者専用サイト",
          title: "お知らせ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "News",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "news/add",
        name: "admin.news.add",
        component: NewsEditPage,
        meta: {
          pageTitle: "お知らせ管理 | 成田養魚園管理者専用サイト",
          title: "お知らせ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "News",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "news/edit/:id",
        name: "admin.news.edit",
        component: NewsEditPage,
        meta: {
          pageTitle: "お知らせ管理 | 成田養魚園管理者専用サイト",
          title: "お知らせ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "News",
          allowRole: [ROLE_ADMIN],
        },
      },
      // {
      //   path: "news/preview/:id",
      //   name: "admin.news.preview",
      //   component: NewsPreviewPage,
      //   meta: {
      //     pageTitle: "お知らせ管理 | 成田養魚園管理者専用サイト",
      //     title: "お知らせ管理 | 成田養魚園管理者専用サイト",
      //     subTitle: "",
      //     className: "News",
      //     allowRole: [ROLE_ADMIN],
      //   },
      // },
      {
        path: "blog",
        name: "admin.blog.index",
        component: BlogListPage,
        meta: {
          pageTitle: "ブログ管理 | 成田養魚園管理者専用サイト",
          title: "ブログ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Blog",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "blog/add",
        name: "admin.blog.add",
        component: BlogEditPage,
        meta: {
          pageTitle: "ブログ管理 | 成田養魚園管理者専用サイト",
          title: "ブログ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Blog",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "blog/edit/:id",
        name: "admin.blog.edit",
        component: BlogEditPage,
        meta: {
          pageTitle: "ブログ管理 | 成田養魚園管理者専用サイト",
          title: "ブログ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Blog",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "store-history",
        name: "admin.store_history.index",
        component: StoreHistoryListPage,
        meta: {
          pageTitle: "ストア注文管理 | 成田養魚園管理者専用サイト",
          title: "ストア注文管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "StoreHistory",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "carpsale-history",
        name: "admin.carpsale_history.index",
        component: CarpsaleHistoryListPage,
        meta: {
          pageTitle: "錦鯉販売注文管理 | 成田養魚園管理者専用サイト",
          title: "錦鯉販売注文管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "KoisaleHistory",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "live",
        name: "admin.live.index",
        component: LiveListPage,
        meta: {
          pageTitle: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          title: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Live",
          allowRole: [ROLE_ADMIN, ROLE_MANAGER],
          allowPermission: ["browse_live"],
        },
      },
      {
        path: "live/add",
        name: "admin.live.add",
        component: LiveCreatePage,
        meta: {
          pageTitle: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          title: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Live",
          allowRole: [ROLE_ADMIN, ROLE_MANAGER],
          allowPermission: ["add_live"],
        },
      },
      {
        path: "live/edit/:id",
        name: "admin.live.edit",
        component: LiveEditPage,
        meta: {
          pageTitle: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          title: "ライブ鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Live",
          allowRole: [ROLE_ADMIN, ROLE_MANAGER],
          allowPermission: ["edit_live"],
        },
      },
      {
        path: "auction",
        name: "admin.auction.index",
        component: AuctionListPage,
        meta: {
          pageTitle: "オークション | 成田養魚園管理者専用サイト",
          title: "オークション | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Auction",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "bid",
        name: "admin.bid.index",
        component: BidListPage,
        meta: {
          pageTitle: "落札鯉管理 | 成田養魚園管理者専用サイト",
          title: "落札鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Bid",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "event",
        name: "admin.event.index",
        component: EventListPage,
        meta: {
          pageTitle: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          title: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Event",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "event/add",
        name: "admin.event.add",
        component: EventEditPage,
        meta: {
          pageTitle:
            "店頭イベントの新規作成・編集 | 成田養魚園管理者専用サイト",
          title: "店頭イベントの新規作成・編集 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Event",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "event/edit/:id",
        name: "admin.event.edit",
        component: EventEditPage,
        meta: {
          pageTitle: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          title: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Event",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "event/recept",
        name: "admin.event.recept",
        component: EventReceptPage,
        meta: {
          pageTitle: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          title: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Event",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "event/setting/:id",
        name: "admin.event.setting",
        component: EventSettingPage,
        meta: {
          pageTitle: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          title: "店頭イベント管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Event",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "contents",
        name: "admin.contents.index",
        component: ContentsListPage,
        meta: {
          pageTitle: "コンテンツアップロード | 成田養魚園管理者専用サイト",
          title: "コンテンツアップロード | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Contents",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "download",
        name: "admin.contents.download",
        component: DownloadListPage,
        meta: {
          pageTitle: "コンテンツダウンロード | 成田養魚園管理者専用サイト",
          title: "コンテンツダウンロード | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Download",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "show",
        name: "admin.show.index",
        component: ShowListPage,
        meta: {
          pageTitle: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          title: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Show",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "show/add",
        name: "admin.show.add",
        component: ShowEditPage,
        meta: {
          pageTitle: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          title: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Show",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "show/edit/:id",
        name: "admin.show.edit",
        component: ShowEditPage,
        meta: {
          pageTitle: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          title: "品評会入賞鯉管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Show",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "magazines",
        name: "admin.magazines.index",
        component: MagazinesListPage,
        meta: {
          pageTitle: "メルマガ管理 | 成田養魚園管理者専用サイト",
          title: "メルマガ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "MailMagazine",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "store",
        name: "admin.store.index",
        component: StoreListPage,
        meta: {
          pageTitle: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          title: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Store",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "store/add",
        name: "admin.store.add",
        component: StoreEditPage,
        meta: {
          pageTitle: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          title: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Store",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "store/edit/:id",
        name: "admin.store.edit",
        component: StoreEditPage,
        meta: {
          pageTitle: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          title: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Store",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "store-category",
        name: "admin.store_category.index",
        component: StoreCategoryListPage,
        meta: {
          pageTitle: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          title: "飼育資材ストア管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "StoreCategory",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "carpsale",
        name: "admin.carpsale.index",
        component: CarpsaleListPage,
        meta: {
          pageTitle: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          title: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Koisale",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "carpsale/add",
        name: "admin.carpsale.add",
        component: CarpsaleEditPage,
        meta: {
          pageTitle: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          title: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Koisale",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "carpsale/edit/:id",
        name: "admin.carpsale.edit",
        component: CarpsaleEditPage,
        meta: {
          pageTitle: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          title: "錦鯉販売管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Koisale",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "carp-category",
        name: "admin.carp_category.index",
        component: CarpCategoryListPage,
        meta: {
          pageTitle: "錦鯉販売カテゴリ管理 | 成田養魚園管理者専用サイト",
          title: "錦鯉販売カテゴリ管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "KoisaleCategory",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "member",
        name: "admin.member.index",
        component: MemberListPage,
        meta: {
          pageTitle: "会員管理 | 成田養魚園管理者専用サイト",
          title: "会員管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Member",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "member/add",
        name: "admin.member.add",
        component: MemberEditPage,
        meta: {
          pageTitle: "会員管理 | 成田養魚園管理者専用サイト",
          title: "会員管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Member",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "member/edit/:id",
        name: "admin.member.edit",
        component: MemberEditPage,
        meta: {
          pageTitle: "会員管理 | 成田養魚園管理者専用サイト",
          title: "会員管理 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Member",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "setting",
        name: "admin.setting.index",
        component: SettingListPage,
        meta: {
          pageTitle: "各種設定 | 成田養魚園管理者専用サイト",
          title: "各種設定 | 成田養魚園管理者専用サイト",
          subTitle: "",
          className: "Dictionary",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "admin/logout",
        name: "admin.logout",
        component: LogoutPage,
      },
      {
        path: "/403",
        name: "forbidden",
        component: forbidden,
      },
      {
        path: "/404",
        name: "notFound",
        component: notFound,
      },
      {
        path: "/serverDown",
        name: "serverDown",
        component: serverDown,
      },
      {
        path: "*",
        component: notFound,
      },
    ],
  },
];

export default adminRouter;
